import React from 'react';
import './HeroSection.css';
import heroVideo from '../imgs/hero-vid.mp4';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section">
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src={heroVideo} type="video/mp4" />
      </video>

      <div className="hero-overlay" />
      <div className="hero-grid" />
      <div className="hero-scan" />

      <div className="hero-corner tl" />
      <div className="hero-corner tr" />
      <div className="hero-corner bl" />
      <div className="hero-corner br" />

      <div className="hero-content">
        <div className="hero-eyebrow">Exotic &amp; Hypercar Specialists</div>

        <h1>KING3DMFG</h1>
        <h2>Precision Fabrication for the World's Finest Cars</h2>

        <p className="hero-description">
          Custom carbon fiber aero, one-off body components, and precision-engineered
          upgrades for Lamborghini, Ferrari, McLaren, and beyond.
        </p>

        <div className="hero-stats">
          <div className="hero-stat">
            <span className="hero-stat-num">±0.1mm</span>
            <span className="hero-stat-label">Tolerance</span>
          </div>
          <div className="hero-stat">
            <span className="hero-stat-num">24hr</span>
            <span className="hero-stat-label">Quote Time</span>
          </div>
          <div className="hero-stat">
            <span className="hero-stat-num">100+</span>
            <span className="hero-stat-label">Builds Completed</span>
          </div>
        </div>

        <div className="hero-buttons">
          <button className="btn-primary" onClick={() => navigate('/services')}>
            Explore Capabilities
          </button>
          <button
            className="btn-outline"
            onClick={() => {
              const el = document.getElementById('quote-form');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Request Custom Build
          </button>
        </div>
      </div>

      <div className="hero-scroll">
        <div className="scroll-line" />
        <span className="scroll-text">Scroll</span>
      </div>
    </section>
  );
};

export default HeroSection;
